module.exports = __webpack_public_path__ + "img/b4.6f5821a1.png";